import { compose } from 'redux'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { withRouter } from 'react-router-dom'
import scriptLoader from 'react-async-script-loader'
import withLocalized from 'modules/localization/withLocalized'
import CoursesMapPage from 'modules/pages/CoursesMapPage'

import * as actions from 'modules/courses/actions'

const getCourses = (state) => state.entities.courses

const courseSelector = ids => createSelector(
  [ getCourses ], (courses) => ids.map(id => courses[id]).filter(club => !!club) //.filter(club => 'organizers' in club).filter(club => club.organizers.length > 0)
)

const handleCourseSelected = (courseID) => {
  return this.props.history.push(`/courses/${courseID}`);
};

const mapStateToProps = (state, ownProps) => {
  
  const {
    ids = [],
    rawCourses,
  } = ownProps
  return {
    courses: rawCourses || courseSelector(ids)(state),
    ...ownProps,
    searchMap: true,
    handleCourseSelected,
  };
};


export default compose(
  scriptLoader('https://maps.googleapis.com/maps/api/js?key=AIzaSyCPmrjBFZz2tspwnpKyT7VvLCER2GQtuK4&libraries=places'),
  withRouter,
  withLocalized,
  connect(mapStateToProps, {
    ...actions
  }),
)(CoursesMapPage)



// WEBPACK FOOTER //
// ./src/containers/CourseMapContainer.js